import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import getImage from '../utils/getImage'

const SEO = ({ postYoastData }) => (
  <StaticQuery
    query={query}
    render={(data) => {
      const siteurl = data?.wp?.seo?.schema?.siteUrl
      const yoastData = postYoastData?.nodes
        ? postYoastData?.nodes[0]?.seo
        : postYoastData
      const postImage =
        getImage(yoastData?.opengraphImage?.localFile, 'original') ||
        getImage(data?.wp?.seo?.schema?.logo?.localFile, 'original')
      const robots = [
        yoastData?.metaRobotsNofollow,
        yoastData?.metaRobotsNoindex,
      ].filter((val) => {
        return val
      })

      return (
        yoastData && (
          <>
            <Helmet title={yoastData?.title}>
              <html lang="en-au" />
              <meta name="facebook-domain-verification" content="ydutjz5l3bmwpuo7pyavmxgjimr5mr" />
              {yoastData?.metaDesc && (
                <meta name="description" content={yoastData.metaDesc} />
              )}
              {yoastData?.opengraphPublishedTime && (
                <meta
                name="article:published_time"
                content={yoastData?.opengraphPublishedTime}
                />
                )}
              {yoastData?.opengraphModifiedTime && (
                <meta
                name="article:modified_time"
                content={yoastData?.opengraphModifiedTime}
                />
                )}
              {postImage && <meta name="image" property="og:image" content={postImage} />}
              {siteurl && <meta property="og:siteUrl" content={siteurl} />}
              {robots?.length && (
                <meta name="robots" content={robots.join(',')} />
              )}
              {(yoastData?.opengraphType ? true : null) && (
                <meta property="og:type" content={yoastData?.opengraphType} />
              )}
              {yoastData?.opengraphTitle && (
                <meta property="og:title" content={yoastData?.opengraphTitle} />
              )}
              {yoastData?.opengraphDescription && (
                <meta
                  property="og:description"
                  content={yoastData?.opengraphDescription}
                />
              )}
              {yoastData?.twitterTitle && (
                <meta
                  name="twitter:title"
                  content={yoastData?.twitterTitle}
                />
              )}
              {postImage && <meta name="twitter:card" content="summary_large_image" />}
              {postImage && <meta name="twitter:image" content={postImage} />}
              {yoastData?.twitterDescription && (
                <meta
                  name="twitter:description"
                  content={yoastData?.twitterDescription}
                />
              )}
            </Helmet>
          </>
        )
      )
    }}
  ></StaticQuery>
)

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  pathname: PropTypes.string,
  article: PropTypes.bool,
  postYoastData: PropTypes.object,
}

SEO.defaultProps = {
  title: null,
  description: null,
  pathname: null,
  article: false,
  postYoastData: null,
}

const query = graphql`
  query SEO {
    wp {
      seo {
        ...GlobalSEOFragment
      }
    }
  }
`

export const GlobalSEOFragment = graphql`
  fragment GlobalSEOFragment on WpSEOConfig {
    schema {
      wordpressSiteName
      siteUrl
      siteName
      companyOrPerson
      companyName
      logo {
        localFile {
          childImageSharp {
            original {
              src
            }
          }
          extension
          publicURL
        }
      }
    }
    social {
      facebook {
        url
      }
      instagram {
        url
      }
      linkedIn {
        url
      }
      twitter {
        username
      }
      youTube {
        url
      }
    }
  }
`

export const SEOFragment = graphql`
  fragment SEOFragment on WpPostTypeSEO {
    canonical
    metaDesc
    metaKeywords
    metaRobotsNofollow
    metaRobotsNoindex
    breadcrumbs {
      text
      url
    }
    opengraphType
    opengraphUrl
    opengraphTitle
    opengraphSiteName
    opengraphPublisher
    opengraphPublishedTime
    opengraphModifiedTime
    opengraphDescription
    opengraphAuthor
    title
    twitterDescription
    focuskw
    twitterImage {
      localFile {
        childImageSharp {
          original {
            src
          }
        }
        extension
        publicURL
      }
    }
    twitterTitle
    opengraphImage {
      localFile {
        childImageSharp {
          original {
            src
          }
        }
        extension
        publicURL
      }
    }
  }
`
